<template>
  <div v-loading="loading" class="registerContent">
    <el-form ref="form" :model="form" label-width="253px">
      <el-form-item label="是否开启身份认证：">
        <el-radio-group v-model="form.requireAuth" @change="isAuthChange">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="authContent" :class="form.requireAuth == 0 ? '' : ''">
        <el-form-item label="身份认证模式	：">
          <el-radio-group v-model="form.authMethod" :disabled="!form.requireAuth">
            <el-radio :label="1">实名认证</el-radio>
            <el-radio :label="2">医生认证</el-radio>
            <el-radio :label="3">实名+医生认证</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否必须通过身份认证：">
          <el-radio-group
            v-model="form.requireAuthToMiniApp"
            :disabled="!form.requireAuth"
            @change="mustAuthToMiniChange"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否允许跳过身份认证	：">
          <el-radio-group
            v-model="form.allowToSkipAuth"
            :disabled="!(form.requireAuth && !form.requireAuthToMiniApp)"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="是否允许邀约添加医生库外的联络人：">
        <el-radio-group v-model="form.allowInviteOutside" @change="canInviceOutDoor">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="allowInviteWithout" :class="form.allowInviteOutside == 0 ? '' : ''">
        <el-form-item label="待验证医生是否允许访问内容：">
          <el-radio-group v-model="form.allowAccessContent" :disabled="!form.allowInviteOutside">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="待验证医生是否可参加会议：">
          <el-radio-group v-model="form.allowJoinMeeting" :disabled="!form.allowInviteOutside">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="待验证医生是否作为参会考核人：">
          <el-radio-group
            v-model="form.waitForVerificationAuditorOrNot"
            :disabled="form.allowInviteWithout == 0 ? true : false"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </div>
      <el-form-item label="二维码类型：">
        <el-radio-group v-model="form.QRCodeType">
          <el-radio :label="1">公众号二维码</el-radio>
          <el-radio :label="0">小程序码</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权书是否可置于注册页内：">
        <el-radio-group v-model="form.allowCertificateInter">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="领域标签是否可跳过：">
        <el-radio-group v-model="form.allowSkipDomain">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可选领域标签上限：">
        <!-- <CountNumberInput
          :can-max-num="2"
          @emitInput="maxTagInput"
          :props-value="form.maxTagNumber"
        /> -->
        <el-input-number v-model="form.domainLimit" controls-position="right" :min="0" :max="5" />
      </el-form-item>
      <!-- <el-form-item label="待验证医生是否允许访问内容	：">
        <el-radio-group v-model="form.allowAccessContent" disabled="">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="待验证医生是否可参加会议	：">
        <el-radio-group v-model="form.allowJoinMeeting">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
    <button class="saveButton" @click="onSubmit">保存</button>
    <DialogComp title2="是否保存" :dialog-visible="dialogVisible" @dialogEmit="saveWrite" />
  </div>
</template>
<script>
// import CountNumberInput from '@/components/countNumberInput';
import DialogComp from '@/components/orange-dialog';
import { getRegisterAuthConfig, setRegisterAuthConfig } from '@/api/setUser';
export default {
  name: 'RegisterAuth',
  components: {
    // CountNumberInput,
    DialogComp,
  },
  data() {
    return {
      loading: false,
      form: {
        requireAuth: false /* 开启身份认证： */,
        authMethod: null /* 认证方式选择： */,
        requireAuthToMiniApp: null /* 必须身份认证通过访问小程序： */,
        allowToSkipAuth: null /* 允许跳过身份认证： */,
        allowInviteOutside: true /* 允许邀约医生库外的联系人： */,
        // waitForVerificationCanVisit: false /* 是否允许待验证医生访问内容： */,
        // waitForVerificationCanMeeting: false /* 是否允许待验证医生参加会议： */,
        // waitForVerificationAuditorOrNot: false /* 待验证医生是否作为参会考核人： */,
        QRCodeType: 1 /* 二维码类型： */,
        allowCertificateInter: true /* 授权书是否可置于注册页内：*/,
        allowSkipDomain: false /* 领域标签是否可跳过： */,
        domainLimit: 2 /* 可选领域标签上限： */,
        allowAccessContent: null /* 是否允许待验证医生访问内容 */,
        allowJoinMeeting: null /* 是否允许待验证医生参加会议 */,
      },
      configType: 80, // 配置类型
      id: undefined, // 企业配置ID
      dialogVisible: false, // 保存弹窗
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取注册认证设置
    async init() {
      // this.loading = true;
      // console.log('13');
      try {
        const res = await getRegisterAuthConfig();
        // this.$nextTick(() => {
        //   this.form = Object.assign(
        //     {},
        //     res
        //   );
        // });
        if (res.requireAuth === false) {
          res.requireAuthToMiniApp = null;
          res.authMethod = null;
          res.allowToSkipAuth = null;
        }
        if (res.allowInviteOutside === false) {
          res.allowAccessContent = null;
          res.allowJoinMeeting = null;
        }
        this.form = Object.assign({}, this.form, res);
      } catch (err) {
        this.$message.error('请求失败');
        console.log('error', err);
      }
      // const res = await this.$requestData('/api/companyConfig/manager/query', {});
      // if (res.data?.code === 0) {
      //   const data = res.data.data?.filter((_) => _.configType === 80);
      //   if (data[0]) {
      //     this.id = data[0].id;
      //     const configText = JSON.parse(data[0]?.configText);
      //     console.log(configText);
      //     if (configText) {
      //       this.$nextTick(() => {
      //         this.form = Object.assign(
      //           {},
      //           {
      //             isAuth: configText.isAuth,
      //             authType: configText.authType,
      //             mustAuthToMini: configText.mustAuthToMini,
      //             allowSkipAuth: configText.allowSkipAuth,
      //             allowInviteWithout: configText.allowInviteWithout,
      //             erweimaType: configText.erweimaType,
      //             authorizationInRegister: configText.authorizationInRegister,
      //             fieldTagIsSkip: configText.fieldTagIsSkip,
      //             maxTagNumber: configText.maxTagNumber,
      //             waitForVerificationCanVisit: configText.waitForVerificationCanVisit,
      //             waitForVerificationCanMeeting: configText.waitForVerificationCanMeeting,
      //             waitForVerificationAuditorOrNot: configText.waitForVerificationAuditorOrNot,
      //           },
      //         );
      //       });
      //     }
      //   }
      // }
      // this.loading = false;
    },
    /* 可选领域标签上限: 文本输入框上传值 */
    maxTagInput(value) {
      this.form.maxTagNumber = value;
    },
    /* 必须身份认证通过访问小程序改变 */
    mustAuthToMiniChange(value) {
      // console.log('value', value);
      if (value) {
        this.$set(this.form, 'allowToSkipAuth', null);
      } else {
        this.$set(this.form, 'allowToSkipAuth', false);
      }
    },
    /* 是否开启身份认证 */
    isAuthChange(val) {
      if (!val) {
        this.$set(this.form, 'authMethod', null);
        this.$set(this.form, 'requireAuthToMiniApp', null);
        this.$set(this.form, 'allowToSkipAuth', null);
      } else {
        this.$set(this.form, 'authMethod', 1);
        this.$set(this.form, 'requireAuthToMiniApp', true);
        this.$set(this.form, 'allowToSkipAuth', null);
      }
    },
    /* 是否允许邀请外部联系人 */
    canInviceOutDoor(val) {
      // console.log(this.form)
      if (!val) {
        this.$set(this.form, 'allowAccessContent', null);
        this.$set(this.form, 'allowJoinMeeting', null);
      } else {
        this.$set(this.form, 'allowAccessContent', false);
        this.$set(this.form, 'allowJoinMeeting', true);
      }
    },
    // 提交数据
    async saveForm() {
      this.loading = true;
      try {
        const res = await setRegisterAuthConfig(this.form);
        console.log('sbumit', res);
      } catch (err) {
        this.$message.error('请求失败');
        console.log('error', err);
      }
      this.loading = false;
    },

    // 保存按钮
    async onSubmit() {
      this.dialogVisible = true;
      // this.loading = true;
      // try {
      //   const res = await this.setRegisterAuthConfig(this.form);
      //   console.log('sbumit', res);
      // } catch (err) {
      //   this.$message.error('请求失败');
      //   console.log('error', err);
      // }
      // this.loading = false;
    },

    // 提示框
    saveWrite(confirm) {
      if (!confirm) {
        this.dialogVisible = false;
        return;
      }

      this.saveForm();
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
